module.exports = __webpack_public_path__ + "static/sesp-480x480-a8027dc0ccb735f8b851cdec5dcfc9d8.png";